import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_EVALUACIONES = 'ALL_EVALUACIONES';
export const LOADING_ALL_EVALUACIONES = 'LOADING_ALL_EVALUACIONES';
export const ACTIVO_EVALUACIONES = 'ACTIVO_EVALUACIONES';
export const PARAMS_EVALUACIONES = 'PARAMS_EVALUACIONES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const evaluacionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_EVALUACIONES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_EVALUACIONES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_EVALUACIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_EVALUACIONES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
